module.exports = __webpack_public_path__ + "static/media/shopping.d4acbfc6.webp";